export const rows = [
  {
    id: 1,
    description: "APPLE INC",
    figi: "BBG000B9XRY4",
    mic: "XNAS",
    symbol: "AAPL",
  },
  {
    id: 2,
    description: "MICROSOFT CORP",
    figi: "BBG000BPH459",
    mic: "XNAS",
    symbol: "MSFT",
  },
  {
    id: 3,
    description: "ALPHABET INC-CL C",
    figi: "BBG009S3NB30",
    mic: "XNAS",
    symbol: "GOOG",
  },
  {
    id: 4,
    description: "AMAZON.COM INC",
    figi: "BBG000BVPV84",
    mic: "XNAS",
    symbol: "AMZN",
  },
  {
    id: 5,
    description: "BERKSHIRE HATHAWAY INC-CL A",
    figi: "BBG000DWCFL4",
    mic: "XNYS",
    symbol: "BRK.A",
  },
  {
    id: 6,
    description: "TESLA INC",
    figi: "BBG000N9MNX3",
    mic: "XNAS",
    symbol: "TSLA",
  },
  {
    id: 7,
    description: "UNITEDHEALTH GROUP INC",
    figi: "BBG000CH5208",
    mic: "XNYS",
    symbol: "UNH",
  },
  {
    id: 8,
    description: "JOHNSON & JOHNSON",
    figi: "BBG000BMHYD1",
    mic: "XNYS",
    symbol: "JNJ",
  },
  {
    id: 9,
    description: "EXXON MOBIL CORP",
    figi: "BBG000GZQ728",
    mic: "XNYS",
    symbol: "XOM",
  },
  {
    id: 10,
    description: "VISA INC-CLASS A SHARES",
    figi: "BBG000PSKYX7",
    mic: "XNYS",
    symbol: "V",
  },
  {
    id: 11,
    description: "NVIDIA CORP",
    figi: "BBG000BBJQV0",
    mic: "XNAS",
    symbol: "NVDA",
  },
  {
    id: 12,
    description: "WESTMOUNTAIN GOLD INC",
    figi: "BBG000BTCB69",
    mic: "OOTC",
    symbol: "WMTN",
  },
  {
    id: 13,
    description: "JPMORGAN CHASE & CO",
    figi: "BBG00N2WDHD0",
    mic: "XNYS",
    symbol: "JPM.PRC",
  },
  {
    id: 14,
    description: "PROCTER & GAMBLE CO/THE",
    figi: "BBG000BR2TH3",
    mic: "XNYS",
    symbol: "PG",
  },
  {
    id: 15,
    description: "ELI LILLY & CO",
    figi: "BBG000BNBDC2",
    mic: "XNYS",
    symbol: "LLY",
  },
  {
    id: 16,
    description: "CHEVRON CORP",
    figi: "BBG000K4ND22",
    mic: "XNYS",
    symbol: "CVX",
  },
  {
    id: 17,
    description: "MASTERCARD INC - A",
    figi: "BBG000F1ZSQ2",
    mic: "XNYS",
    symbol: "MA",
  },
  {
    id: 18,
    description: "HOME DEPOT INC",
    figi: "BBG000BKZB36",
    mic: "XNYS",
    symbol: "HD",
  },
  {
    id: 19,
    description: "META PLATFORMS INC-CLASS A",
    figi: "BBG000MM2P62",
    mic: "XNAS",
    symbol: "FB",
  },
  {
    id: 20,
    description: "BANK OF AMERICA CORP",
    figi: "BBG000BCTLF6",
    mic: "XNYS",
    symbol: "BAC",
  },
  {
    id: 21,
    description: "ABBVIE INC",
    figi: "BBG0025Y4RY4",
    mic: "XNYS",
    symbol: "ABBV",
  },
  {
    id: 22,
    description: "PFIZER INC",
    figi: "BBG000BR2B91",
    mic: "XNYS",
    symbol: "PFE",
  },
  {
    id: 23,
    description: "MERCK & CO. INC.",
    figi: "BBG000BPD168",
    mic: "XNYS",
    symbol: "MRK",
  },
  {
    id: 24,
    description: "COCA-COLA CO/THE",
    figi: "BBG000BMX289",
    mic: "XNYS",
    symbol: "KO",
  },
  {
    id: 25,
    description: "PEPSICO INC",
    figi: "BBG000DH7JK6",
    mic: "XNAS",
    symbol: "PEP",
  },
  {
    id: 26,
    description: "BROADCOM INC",
    figi: "BBG00KHY5S69",
    mic: "XNAS",
    symbol: "AVGO",
  },
  {
    id: 27,
    description: "ORACLE CORP",
    figi: "BBG000BQLTW7",
    mic: "XNYS",
    symbol: "ORCL",
  },
  {
    id: 28,
    description: "THERMO FISHER SCIENTIFIC INC",
    figi: "BBG000BVDLH9",
    mic: "XNYS",
    symbol: "TMO",
  },
  {
    id: 29,
    description: "COSTCO WHOLESALE CORP",
    figi: "BBG000F6H8W8",
    mic: "XNAS",
    symbol: "COST",
  },
  {
    id: 30,
    description: "CISCO SYSTEMS INC",
    figi: "BBG000C3J3C9",
    mic: "XNAS",
    symbol: "CSCO",
  },
  {
    id: 31,
    description: "MCDONALD'S CORP",
    figi: "BBG000BNSZP1",
    mic: "XNYS",
    symbol: "MCD",
  },
  {
    id: 32,
    description: "DANAHER CORP",
    figi: "BBG000BH3JF8",
    mic: "XNYS",
    symbol: "DHR",
  },
  {
    id: 33,
    description: "ACCENTURE PLC-CL A",
    figi: "BBG000D9D830",
    mic: "XNYS",
    symbol: "ACN",
  },
  {
    id: 34,
    description: "T-MOBILE US INC",
    figi: "BBG000NDV1D4",
    mic: "XNAS",
    symbol: "TMUS",
  },
  {
    id: 35,
    description: "ABBOTT LABORATORIES",
    figi: "BBG000B9ZXB4",
    mic: "XNYS",
    symbol: "ABT",
  },
  {
    id: 36,
    description: "WALT DISNEY CO/THE",
    figi: "BBG000BH4R78",
    mic: "XNYS",
    symbol: "DIS",
  },
  {
    id: 37,
    description: "NIKE INC -CL B",
    figi: "BBG000C5HS04",
    mic: "XNYS",
    symbol: "NKE",
  },
  {
    id: 38,
    description: "WELLS FARGO & CO",
    figi: "BBG000BWQFY7",
    mic: "XNYS",
    symbol: "WFC",
  },
  {
    id: 39,
    description: "BRISTOL-MYERS SQUIBB CO",
    figi: "BBG000DQLV23",
    mic: "XNYS",
    symbol: "BMY",
  },
  {
    id: 40,
    description: "NEXTERA ENERGY INC",
    figi: "BBG000BJSBJ0",
    mic: "XNYS",
    symbol: "NEE",
  },
  {
    id: 41,
    description: "LINDE PLC",
    figi: "BBG00GVR8YQ9",
    mic: "XNYS",
    symbol: "LIN",
  },
  {
    id: 42,
    description: "UNITED PARCEL SERVICE-CL B",
    figi: "BBG000L9CV04",
    mic: "XNYS",
    symbol: "UPS",
  },
  {
    id: 43,
    description: "PHILIP MORRIS INTERNATIONAL",
    figi: "BBG000J2XL74",
    mic: "XNYS",
    symbol: "PM",
  },
  {
    id: 44,
    description: "TEXAS INSTRUMENTS INC",
    figi: "BBG000BVV7G45",
    mic: "XNAS",
    symbol: "TXN",
  },
  {
    id: 45,
    description: "VERIZON COMMUNICATIONS INC",
    figi: "BBG000HS77T5",
    mic: "XNYS",
    symbol: "VZ",
  },
  {
    id: 46,
    description: "ADOBE INC",
    figi: "BBG000BB5006",
    mic: "XNAS",
    symbol: "ADBE",
  },
  {
    id: 47,
    description: "MORGAN STANLEY",
    figi: "BBG000BLZRJ2",
    mic: "XNYS",
    symbol: "MS",
  },
  {
    id: 48,
    description: "COMCAST CORP-CLASS A",
    figi: "BBG000BFT2L4",
    mic: "XNAS",
    symbol: "CMCSA",
  },
  {
    id: 49,
    description: "SCHWAB (CHARLES) CORP",
    figi: "BBG000BSLZY7",
    mic: "XNYS",
    symbol: "SCHW",
  },
  {
    id: 50,
    description: "AMGEN INC",
    figi: "BBG000BBS2Y0",
    mic: "XNAS",
    symbol: "AMGN",
  },
  {
    id: 51,
    description: "CONOCOPHILLIPS",
    figi: "BBG000BQQH30",
    mic: "XNYS",
    symbol: "COP",
  },
  {
    id: 52,
    description: "RAYTHEON TECHNOLOGIES CORP",
    figi: "BBG000BW8S60",
    mic: "XNYS",
    symbol: "RTX",
  },
  {
    id: 53,
    description: "HONEYWELL INTERNATIONAL INC",
    figi: "BBG000H556T9",
    mic: "XNAS",
    symbol: "HON",
  },
  {
    id: 54,
    description: "SALESFORCE INC",
    figi: "BBG000BN2DC2",
    mic: "XNYS",
    symbol: "CRM",
  },
  {
    id: 55,
    description: "NETFLIX INC",
    figi: "BBG000CL9VN6",
    mic: "XNAS",
    symbol: "NFLX",
  },
  {
    id: 56,
    description: "QUALCOMM INC",
    figi: "BBG000CGC1X8",
    mic: "XNAS",
    symbol: "QCOM",
  },
  {
    id: 57,
    description: "AT&T INC",
    figi: "BBG000BSJK37",
    mic: "XNYS",
    symbol: "T",
  },
  {
    id: 58,
    description: "CVS HEALTH CORP",
    figi: "BBG000BGRY34",
    mic: "XNYS",
    symbol: "CVS",
  },
  {
    id: 59,
    description: "DEERE & CO",
    figi: "BBG000BH1NH9",
    mic: "XNYS",
    symbol: "DE",
  },
  {
    id: 60,
    description: "INTL BUSINESS MACHINES CORP",
    figi: "BBG000BLNNH6",
    mic: "XNYS",
    symbol: "IBM",
  },
];
